import React, { useState } from 'react'

const Qualification = () => {
  const [workTab, setWorkTab] = useState(true);
  const [eduTab, setEduTab] = useState(false);

  const toggleWork = () => {
    setEduTab(false);
    setWorkTab(true);
  }

  const toggleEdu = () => {
    setWorkTab(false);
    setEduTab(true);
  }

  return (
      <section className='qualification section'>
          <h2 className="section__title">Qualification</h2>
          <span className="section__subtitle">Personal Journey</span>

          <div className='qualification__container container'>
            <div className="qualification__tabs">
                <div className={workTab ? 'qualification__button button__flex qualification__active' : 'qualification__button button__flex'} data-target="#work" onClick={toggleWork}>
                    <i className="uil uil-bag qualification__icon"></i>
                    Work
                </div>
                <div className={eduTab ? 'qualification__button button__flex qualification__active' : 'qualification__button button__flex'} data-target="#education" onClick={toggleEdu}>
                    <i className="uil uil-graduation-cap qualification__icon"></i>
                    Education
                </div>
            </div>

            <div className="qualification__sections">
                {/* ================== Content 1 ============================= */}
                <div className={workTab ? 'qualification__content qualification__active' : 'qualification__content'} data-content id="work">
                    
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">Senior Product Engineer</h3>
                            <span className="qualification__subtitle">Vinnovate Technologies - Remote(India)</span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt qualification__icon"></i> 2022 - Present
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                    </div>

                    
                    <div className="qualification__data">
                        <div></div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                        <div>
                            <h3 className="qualification__title">Fullstack Web Developer</h3>
                            <span className="qualification__subtitle">Iconblocks - Remote(USA)</span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt qualification__icon"></i> 2021 - 2022
                            </div>
                        </div>
                    </div>

                    <div className="qualification__data">
                        <div></div>
                        <div>
                            <span className="qualification__rounder"></span>
                        </div>
                        <div>
                            <h3 className="qualification__title">Web Developer</h3>
                            <span className="qualification__subtitle">Vinnovate Technologies - Remote(India)</span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt qualification__icon"></i> 2020 - 2021
                            </div>
                        </div>
                    </div>
                </div>

                {/* ================== Content 2 ============================= */}
                <div className={eduTab ? 'qualification__content qualification__active' : 'qualification__content'} data-content id="education">
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">BSc (Hons) Software Engineering</h3>
                            <span className="qualification__subtitle">Solent Southampton University - UK</span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt qualification__icon"></i> 2019 - 2020
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                    </div>

                    <div className="qualification__data">
                        <div></div>
                        <div>
                            <span className="qualification__rounder"></span>
                        </div>
                        <div>
                            <h3 className="qualification__title">HND in Computing and Systems Development</h3>
                            <span className="qualification__subtitle">Pearson, Edexcel - UK</span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt qualification__icon"></i> 2017 - 2018
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          </div>



      </section>
  )
}

export default Qualification;